export default __webpack_public_path__ + "static/media/tausendsassa-element.a6f251bb.jpg";